import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';
import { string } from 'yup';
import socket from '@/socket';
import moment from 'moment'

const toast = useToast();
const useCommonStore = defineStore({
    id: 'common',
    state: () => ({
        openingHours: {
            weekdays: {
                startTime1: '8:30',
                endTime1: '13:00',
                startLunchTime: '13:00',
                endLunchTime: '14:00',
                startTime2: '14:00',
                endTime2: '18:00'
            },
            saturday: {
                startTime: '8:30',
                endTime: '13:00'
            },
            appointmentTimeslot: 15
        },
        publicHolidayList: []
    }),
    getters: {},
    actions: {
        getImgUrl(componentName: String, imgName: String, imgFormat: String) {
            return new URL(`../assets/images/${componentName}/${imgName}.${imgFormat}`, import.meta.url).href;
        },
        getVideoUrl(videoName: String, videoFormat: String) {
            return new URL(`../assets/video/${videoName}.${videoFormat}`, import.meta.url).href;
        },
        getAttachmentUrl(fileName: String, fileFormat: String) {
            return new URL(`../assets/attachments/${fileName}.${fileFormat}`, import.meta.url).href;
        },
        getColor(color: String, type: String) {
            if (color.includes("#")) {
                var result = type + "-[" + color + "]";
                return result;
            } else {
                result = type + "-" + color;
                return result;
            }
        },
        async getHKPublicHoliday() {
            try {
                console.log('api: get hk public holiday');
                var body = {
                    value: 'true'
                }
                var response: any = await apiClient.post('/api/scwebsite/getHKPublicHoliday', body);
                const isSuccess = response.statusCode;
                if (!isSuccess) {
                    //debugger;
                    console.log('response? ' + JSON.stringify(response));
                    //var error = Object.prototype.toString.call(response.errorMessage) === '[object Object]' ? JSON.stringify(response.errorMessage) : response.errorMessage;
                    response = this.hardCodePublicHoliday();
                    //throw new Error(error)
                }
                //toast.success('Send Email Success');
                //debugger;
                response.result.forEach(element => {
                    if (element.description == "Public holiday") {
                        let date = element.start.date;
                        let unix = moment(element.start.date).format('x');
                        let dateObj = { date, unix };
                        useCommonStore().publicHolidayList.push(dateObj);
                    }

                });
                return isSuccess;
            } catch (err: any) {
                //toast.error(err.message);
            }
        },
        //generate from the api, 2022 public holiday
        hardCodePublicHoliday() {
            return {
                "statusCode": 1,
                "result": [
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943549596000\"",
                        "id": "20220405_spelcjk6jncq6ad2796du1u4m8",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA0MDVfc3BlbGNqazZqbmNxNmFkMjc5NmR1MXU0bTggemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:14.000Z",
                        "updated": "2021-08-26T09:56:14.798Z",
                        "summary": "Tomb Sweeping Day",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-04-05"
                        },
                        "end": {
                            "date": "2022-04-06"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220405_spelcjk6jncq6ad2796du1u4m8@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943549596000\"",
                        "id": "20220508_lse284qncq7a55pru42cacl2u8",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA1MDhfbHNlMjg0cW5jcTdhNTVwcnU0MmNhY2wydTggemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:14.000Z",
                        "updated": "2021-08-26T09:56:14.798Z",
                        "summary": "Mother's Day",
                        "description": "Observance\nTo hide observances, go to Google Calendar Settings > Holidays in Hong Kong",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-05-08"
                        },
                        "end": {
                            "date": "2022-05-09"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220508_lse284qncq7a55pru42cacl2u8@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943549596000\"",
                        "id": "20220509_m6akcemg697ejcf7rm3lccjk1k",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA1MDlfbTZha2NlbWc2OTdlamNmN3JtM2xjY2prMWsgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:14.000Z",
                        "updated": "2021-08-26T09:56:14.798Z",
                        "summary": "Day following Buddha's Birthday",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-05-09"
                        },
                        "end": {
                            "date": "2022-05-10"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220509_m6akcemg697ejcf7rm3lccjk1k@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943549596000\"",
                        "id": "20220812_qeak289ce7d11iraii9n01ot6g",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA4MTJfcWVhazI4OWNlN2QxMWlyYWlpOW4wMW90NmcgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:14.000Z",
                        "updated": "2021-08-26T09:56:14.798Z",
                        "summary": "Hungry Ghost Festival",
                        "description": "Observance\nTo hide observances, go to Google Calendar Settings > Holidays in Hong Kong",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-08-12"
                        },
                        "end": {
                            "date": "2022-08-13"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220812_qeak289ce7d11iraii9n01ot6g@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943549596000\"",
                        "id": "20221001_if45ifu0oo94oil0k32caii2o8",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjEwMDFfaWY0NWlmdTBvbzk0b2lsMGszMmNhaWkybzggemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:14.000Z",
                        "updated": "2021-08-26T09:56:14.798Z",
                        "summary": "National Day of the People's Republic of China",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-10-01"
                        },
                        "end": {
                            "date": "2022-10-02"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20221001_if45ifu0oo94oil0k32caii2o8@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943549596000\"",
                        "id": "20221225_dj7uq2nihvju06rlr5p8sjqimo",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjEyMjVfZGo3dXEybmlodmp1MDZybHI1cDhzanFpbW8gemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:14.000Z",
                        "updated": "2021-08-26T09:56:14.798Z",
                        "summary": "Christmas Day",
                        "description": "Observance\nTo hide observances, go to Google Calendar Settings > Holidays in Hong Kong",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-12-25"
                        },
                        "end": {
                            "date": "2022-12-26"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20221225_dj7uq2nihvju06rlr5p8sjqimo@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943554520000\"",
                        "id": "20220101_757b8c0801nu2qua5hi4atdbfg",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjAxMDFfNzU3YjhjMDgwMW51MnF1YTVoaTRhdGRiZmcgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:17.000Z",
                        "updated": "2021-08-26T09:56:17.260Z",
                        "summary": "New Year's Day",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-01-01"
                        },
                        "end": {
                            "date": "2022-01-02"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220101_757b8c0801nu2qua5hi4atdbfg@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943554520000\"",
                        "id": "20220701_bo41ngbbshkhtjs0mq5vivf8r4",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA3MDFfYm80MW5nYmJzaGtodGpzMG1xNXZpdmY4cjQgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:17.000Z",
                        "updated": "2021-08-26T09:56:17.260Z",
                        "summary": "Hong Kong Special Administrative Region Establishment Day",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-07-01"
                        },
                        "end": {
                            "date": "2022-07-02"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220701_bo41ngbbshkhtjs0mq5vivf8r4@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943554520000\"",
                        "id": "20221227_4nk1b5bui905vqeb5e1p2imkds",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjEyMjdfNG5rMWI1YnVpOTA1dnFlYjVlMXAyaW1rZHMgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:17.000Z",
                        "updated": "2021-08-26T09:56:17.260Z",
                        "summary": "Second Weekday After Christmas Day",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-12-27"
                        },
                        "end": {
                            "date": "2022-12-28"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20221227_4nk1b5bui905vqeb5e1p2imkds@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943554520000\"",
                        "id": "20221231_q0pqjua1avdfehj80pu76gj1j0",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjEyMzFfcTBwcWp1YTFhdmRmZWhqODBwdTc2Z2oxajAgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:17.000Z",
                        "updated": "2021-08-26T09:56:17.260Z",
                        "summary": "New Year's Eve",
                        "description": "Observance\nTo hide observances, go to Google Calendar Settings > Holidays in Hong Kong",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-12-31"
                        },
                        "end": {
                            "date": "2023-01-01"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20221231_q0pqjua1avdfehj80pu76gj1j0@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943558846000\"",
                        "id": "20220214_rgm869qm8561o24u4kph6se48g",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjAyMTRfcmdtODY5cW04NTYxbzI0dTRrcGg2c2U0OGcgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:19.000Z",
                        "updated": "2021-08-26T09:56:19.423Z",
                        "summary": "Valentine's Day",
                        "description": "Observance\nTo hide observances, go to Google Calendar Settings > Holidays in Hong Kong",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-02-14"
                        },
                        "end": {
                            "date": "2022-02-15"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220214_rgm869qm8561o24u4kph6se48g@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943558846000\"",
                        "id": "20220416_c405g9ddukeu158bsp9mkqvkvg",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA0MTZfYzQwNWc5ZGR1a2V1MTU4YnNwOW1rcXZrdmcgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:19.000Z",
                        "updated": "2021-08-26T09:56:19.423Z",
                        "summary": "Holy Saturday",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-04-16"
                        },
                        "end": {
                            "date": "2022-04-17"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220416_c405g9ddukeu158bsp9mkqvkvg@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943558846000\"",
                        "id": "20220418_d6apjtarq0ubt59mnr436u8ma4",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA0MThfZDZhcGp0YXJxMHVidDU5bW5yNDM2dThtYTQgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:19.000Z",
                        "updated": "2021-08-26T09:56:19.423Z",
                        "summary": "Easter Monday",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-04-18"
                        },
                        "end": {
                            "date": "2022-04-19"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220418_d6apjtarq0ubt59mnr436u8ma4@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943558846000\"",
                        "id": "20220501_jkp4qfoeudnjtdphj2sl6n7c4s",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA1MDFfamtwNHFmb2V1ZG5qdGRwaGoyc2w2bjdjNHMgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:19.000Z",
                        "updated": "2021-08-26T09:56:19.423Z",
                        "summary": "Labour Day",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-05-01"
                        },
                        "end": {
                            "date": "2022-05-02"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220501_jkp4qfoeudnjtdphj2sl6n7c4s@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943558846000\"",
                        "id": "20220502_peb42dg50pdoujnjksbh5onanc",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA1MDJfcGViNDJkZzUwcGRvdWpuamtzYmg1b25hbmMgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:19.000Z",
                        "updated": "2021-08-26T09:56:19.423Z",
                        "summary": "Labour Day observed",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-05-02"
                        },
                        "end": {
                            "date": "2022-05-03"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220502_peb42dg50pdoujnjksbh5onanc@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943558846000\"",
                        "id": "20220508_5letaog0ki9p9npni7f7un58d8",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA1MDhfNWxldGFvZzBraTlwOW5wbmk3Zjd1bjU4ZDggemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:19.000Z",
                        "updated": "2021-08-26T09:56:19.423Z",
                        "summary": "Buddha's Birthday",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-05-08"
                        },
                        "end": {
                            "date": "2022-05-09"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220508_5letaog0ki9p9npni7f7un58d8@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943558846000\"",
                        "id": "20220619_s3pnf8pr7q4cfs8o36bc8ao5fc",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA2MTlfczNwbmY4cHI3cTRjZnM4bzM2YmM4YW81ZmMgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:19.000Z",
                        "updated": "2021-08-26T09:56:19.423Z",
                        "summary": "Father's Day",
                        "description": "Observance\nTo hide observances, go to Google Calendar Settings > Holidays in Hong Kong",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-06-19"
                        },
                        "end": {
                            "date": "2022-06-20"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220619_s3pnf8pr7q4cfs8o36bc8ao5fc@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943558846000\"",
                        "id": "20221004_pe1jmc6s3h38ljv2l30v9e3968",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjEwMDRfcGUxam1jNnMzaDM4bGp2MmwzMHY5ZTM5NjggemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:19.000Z",
                        "updated": "2021-08-26T09:56:19.423Z",
                        "summary": "Chung Yeung Festival",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-10-04"
                        },
                        "end": {
                            "date": "2022-10-05"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20221004_pe1jmc6s3h38ljv2l30v9e3968@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943558846000\"",
                        "id": "20221226_qk7qrd4vhfu16kqh8tcqr8n7js",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjEyMjZfcWs3cXJkNHZoZnUxNmtxaDh0Y3FyOG43anMgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:19.000Z",
                        "updated": "2021-08-26T09:56:19.423Z",
                        "summary": "First Weekday After Christmas Day",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-12-26"
                        },
                        "end": {
                            "date": "2022-12-27"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20221226_qk7qrd4vhfu16kqh8tcqr8n7js@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943562328000\"",
                        "id": "20220912_gigb3smsq55vr1j2t7uiph6004",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA5MTJfZ2lnYjNzbXNxNTV2cjFqMnQ3dWlwaDYwMDQgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:21.000Z",
                        "updated": "2021-08-26T09:56:21.164Z",
                        "summary": "Day after Mid-Autumn Festival",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-09-12"
                        },
                        "end": {
                            "date": "2022-09-13"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220912_gigb3smsq55vr1j2t7uiph6004@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943565506000\"",
                        "id": "20220415_d8q5dsqvj67d6k0522uvcliau0",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA0MTVfZDhxNWRzcXZqNjdkNmswNTIydXZjbGlhdTAgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:22.000Z",
                        "updated": "2021-08-26T09:56:22.753Z",
                        "summary": "Good Friday",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-04-15"
                        },
                        "end": {
                            "date": "2022-04-16"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220415_d8q5dsqvj67d6k0522uvcliau0@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943565506000\"",
                        "id": "20220417_gpcfii7l5gsennb59fu6cj0d4k",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA0MTdfZ3BjZmlpN2w1Z3Nlbm5iNTlmdTZjajBkNGsgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:22.000Z",
                        "updated": "2021-08-26T09:56:22.753Z",
                        "summary": "Easter Sunday",
                        "description": "Observance\nTo hide observances, go to Google Calendar Settings > Holidays in Hong Kong",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-04-17"
                        },
                        "end": {
                            "date": "2022-04-18"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220417_gpcfii7l5gsennb59fu6cj0d4k@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943568894000\"",
                        "id": "20220603_ss2m2t7b7gkgheeocifcstd6ek",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA2MDNfc3MybTJ0N2I3Z2tnaGVlb2NpZmNzdGQ2ZWsgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:24.000Z",
                        "updated": "2021-08-26T09:56:24.447Z",
                        "summary": "Dragon Boat Festival",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-06-03"
                        },
                        "end": {
                            "date": "2022-06-04"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220603_ss2m2t7b7gkgheeocifcstd6ek@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3259943568894000\"",
                        "id": "20220910_ssk98109jk9q7q9vk19ukubc1g",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjA5MTBfc3NrOTgxMDlqazlxN3E5dmsxOXVrdWJjMWcgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2021-08-26T09:56:24.000Z",
                        "updated": "2021-08-26T09:56:24.447Z",
                        "summary": "Mid-Autumn Festival",
                        "description": "Observance\nTo hide observances, go to Google Calendar Settings > Holidays in Hong Kong",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-09-10"
                        },
                        "end": {
                            "date": "2022-09-11"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220910_ssk98109jk9q7q9vk19ukubc1g@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3286333910098000\"",
                        "id": "20220201_02qhr1nsuq855dmj1r7fjp7qu0",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjAyMDFfMDJxaHIxbnN1cTg1NWRtajFyN2ZqcDdxdTAgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2022-01-26T03:15:55.000Z",
                        "updated": "2022-01-26T03:15:55.049Z",
                        "summary": "Lunar New Year's Day",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-02-01"
                        },
                        "end": {
                            "date": "2022-02-02"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220201_02qhr1nsuq855dmj1r7fjp7qu0@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3294021425306000\"",
                        "id": "20220202_vqfiltujdsb7jbc76o001oidek",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjAyMDJfdnFmaWx0dWpkc2I3amJjNzZvMDAxb2lkZWsgemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2022-03-11T14:58:32.000Z",
                        "updated": "2022-03-11T14:58:32.653Z",
                        "summary": "Second Day of Lunar New Year",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-02-02"
                        },
                        "end": {
                            "date": "2022-02-03"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220202_vqfiltujdsb7jbc76o001oidek@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    },
                    {
                        "kind": "calendar#event",
                        "etag": "\"3294021425306000\"",
                        "id": "20220203_a0as7m2b0ndo855v211jn0rqf8",
                        "status": "confirmed",
                        "htmlLink": "https://www.google.com/calendar/event?eid=MjAyMjAyMDNfYTBhczdtMmIwbmRvODU1djIxMWpuMHJxZjggemgtdHcuaG9uZ19rb25nI2hvbGlkYXlAdg",
                        "created": "2022-03-11T14:58:32.000Z",
                        "updated": "2022-03-11T14:58:32.653Z",
                        "summary": "Third Day of Lunar New Year",
                        "description": "Public holiday",
                        "creator": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "organizer": {
                            "email": "zh-tw.hong_kong#holiday@group.v.calendar.google.com",
                            "displayName": "香港節慶假日",
                            "self": true
                        },
                        "start": {
                            "date": "2022-02-03"
                        },
                        "end": {
                            "date": "2022-02-04"
                        },
                        "transparency": "transparent",
                        "visibility": "public",
                        "iCalUID": "20220203_a0as7m2b0ndo855v211jn0rqf8@google.com",
                        "sequence": 0,
                        "eventType": "default"
                    }
                ]
            }
        }
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useCommonStore, import.meta.hot));
}

export { useCommonStore };
